<script setup lang="ts">
import { useEventsApi } from '~/composables/api/use-events-api';

definePageMeta({ layout: 'marketing' });

const config = useRuntimeConfig();

useHead(
  {
    title: 'Arvee Events — Say Yes with Confidence',
    meta: [
      {
        name: 'description',
        content:
          'Threshold-funded RV events with transparent budgets, locked details, and organizer accountability. If enough people commit, it happens. If not, no one gets burned.',
      },
      {
        property: 'og:title',
        content: 'Arvee Events — Say Yes with Confidence',
      },
      {
        property: 'og:description',
        content:
          'Threshold-funded RV events with transparent budgets and organizer accountability. Browse upcoming rallies, meetups, and adventures.',
      },
      { property: 'og:image', content: 'https://events.arvee.io/og-image.jpg' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://events.arvee.io/' },
      { name: 'twitter:card', content: 'summary_large_image' },
    ],
    link: [{ rel: 'canonical', href: 'https://events.arvee.io/' }],
    script: [
      {
        type: 'application/ld+json',
        innerHTML: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: 'Arvee Events',
          url: 'https://events.arvee.io/',
          description:
            'Threshold-funded RV events with transparent budgets, locked details, and organizer accountability.',
        }),
      },
    ],
  },
  { tagPriority: 10 },
);

const { data, status } = useAsyncData(
  'featured-events',
  () => useEventsApi().browse({ per_page: 6 }),
  { server: !config.public.mock },
);

const featuredEvents = computed(() => data.value?.data ?? []);
const isLoading = computed(
  () => status.value === 'pending' || status.value === 'idle',
);
</script>

<template>
  <div>
    <MarketingHeroSection />
    <MarketingHowItWorksSection />
    <MarketingFeaturedEventsSection
      :events="featuredEvents"
      :loading="isLoading"
    />
    <MarketingIdeasSection />
    <MarketingWhyArveeSection />
    <MarketingEventTypesSection />
    <MarketingOrganizeSection />
    <MarketingCommunitySection />
  </div>
</template>
